<!-- 小程序下拉框的搜索 -->
<template>
<div>
	<a-select
		:mode="mode_type == 'dan'?'':'multiple'"
		:style="{'width': s_width?s_width:'260px'}"
		placeholder="请选择小程序"
		:filter-option="false"
		@change="handleChangeS"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollHandle" 
		showSearch
		:allowClear="page_type == 'gzhFans'?false : true"
		@search="selectZhSearch"
		:not-found-content="s_fetching ? undefined : null" 
		@blur="zhBlur" 
		:value="select_value"
	  >
		<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
		
		<a-select-option v-for="(item,index) in showFilterData" :key="item.appid" :value="item.appid" :title="item.applets_name">
		  {{item.applets_name}}
		</a-select-option>
		<a-select-option v-if="loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
	
</div>
</template>

<script>
import { selectXsVdApplets } from '@/request/api'
export default {
	name: 'searchLinkSelect_',
	props: ['page_type','mode_type','s_width'],
	data(){
		return {
			select_value: [], // 选择的广告账户
			showFilterData: [], // 选择广告账户
			s_page: 1,
			s_limit: 50,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			showFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_q: null,
		}
	},
	mounted(){
		// console.log("page-type",this.page_type)
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		setValue(vvv){
			this.select_value = vvv
		},
		getSelectData(e,type,handle){
			let that = this
			
			if(handle == 'clear'){
				that.select_value = undefined
			}
			
			that.r_q = e || null
			selectXsVdApplets({
				page: 1,
				limit: that.s_limit,
				
				plat_channel: that.r_q,
			}).then(res=>{
				// console.log("获取小程序",res)
				// if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.showFilterData = res.data.data.list || []
					
					// that.showFilterData = res.data.slice(that.s_page, that.s_limit)
					// that.showFilterSearch = res.data
					that.showFilterBlur = res.data.data.list || []
				// }
				// else {
				// 	that.$message.error(`错误：${res.data.msg}`);
				// }
			})
			
		},
		
		handleChangeS(value) {
			this.select_value = value
			this.$emit('handleChangeSelect', value)
			
		},
		
		popupScrollHandle(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					selectXsVdApplets({
						page: that.s_page,
						limit: that.s_limit,
						name: that.s_adv_name,
						
						plat_channel: that.r_q,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.showFilterData 
						that.loading_more_hint = false
						// if(res.data.data.list.length > 0){
						// 	that.showFilterData = data.concat(res.data.data.list)
						// }
						that.s_fetching = false
						
						
						if(that.showFilterData.length < res.data.data.total){
							that.showFilterData = data.concat(res.data.data.list)
							that.loading_more_control = true
						}
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.showFilterData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			selectXsVdApplets({
				page: 1,
				limit: that.s_limit,
				
				applets_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.showFilterData = res.data.data.list
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.showFilterData = that.showFilterBlur 
			
			that.loading_more_control = true
		},
	}
}
</script>

<style scoped>

</style>